export default {
    GET_ALL_PAYMENT_GATEWAYS_LOADING: 'GET_ALL_PAYMENT_GATEWAYS_LOADING',
    GET_ALL_PAYMENT_GATEWAYS_SUCCESS: 'GET_ALL_PAYMENT_GATEWAYS_SUCCESS',
    GET_ALL_PAYMENT_GATEWAYS_FAILED: 'GET_ALL_PAYMENT_GATEWAYS_FAILED',
    GET_ALL_PAYMENT_GATEWAYS_REJECT: 'GET_ALL_PAYMENT_GATEWAYS_REJECT',

    GET_PAYMENT_REDIRECT_LOADING: 'GET_PAYMENT_REDIRECT_LOADING',
    GET_PAYMENT_REDIRECT_SUCCESS: 'GET_PAYMENT_REDIRECT_SUCCESS',
    GET_PAYMENT_REDIRECT_FAILED: 'GET_PAYMENT_REDIRECT_FAILED',
    GET_PAYMENT_REDIRECT_REJECT: 'GET_PAYMENT_REDIRECT_REJECT',

    PAYMENT_REQUEST_LOADING: 'PAYMENT_REQUEST_LOADING',
    PAYMENT_REQUEST_SUCCESS: 'PAYMENT_REQUEST_SUCCESS',
    PAYMENT_REQUEST_FAILED: 'PAYMENT_REQUEST_FAILED',
    PAYMENT_REQUEST_REJECT: 'PAYMENT_REQUEST_REJECT',
  };